export default __webpack_public_path__ + "static/customer2-9a68932a13505e94b4716f9fc0058b12.jpg";